<template>
	<div id="bannerWrapper">
		<button
			class="button-icon light button-close"
			type="button"
			@click.stop.prevent="$emit('dismiss')"
		>
			<img src="@/assets/img/icons/round-close-24px.svg" />
		</button>
		<span id="bannerMessage">
			<slot name="message"></slot>
		</span>
		<span>
			<button type="button" class="button secondary" @click.stop.prevent="$emit('actionClick')">
				<slot name="action"></slot>
			</button>
		</span>
	</div>
</template>

<script>
export default {};
</script>

<style>
#bannerWrapper {
	display: flex;
	justify-content: center;
	align-items: center;

	width: 100%;
	height: 72px;

	position: absolute;
	top: 0;
	left: 0;

	box-shadow: 0px 1px 6px rgba(35, 38, 43, 0.15);

	z-index: 999;
}

#bannerWrapper.success {
	background-color: #eff9f0;
}

#bannerWrapper.error {
	background-color: #fcf0f4;
}

#bannerMessage {
	margin-right: 16px;
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
}
</style>